import type { ReactNode } from 'react'

interface DialogFieldProps {
  label: string
  type?: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  light?: boolean
}

export function DialogField({ label, type = 'text', placeholder, value, onChange, light }: DialogFieldProps) {
  return (
    <div className="sg-dialog__field">
      <label className="sg-dialog__label" style={light ? { color: 'rgba(26,31,22,0.7)' } : undefined}>
        {label}
      </label>
      <input
        className={`sg-dialog__input${light ? ' sg-dialog__input--light' : ''}`}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange ? e => onChange(e.target.value) : undefined}
        readOnly={!onChange}
      />
    </div>
  )
}

interface DialogFormProps {
  children: ReactNode
}

export default function DialogForm({ children }: DialogFormProps) {
  return (
    <div className="sg-dialog__form">
      {children}
    </div>
  )
}
